import {Component, Input} from '@angular/core';
import {FileDownloadService} from './file_download.service';
import {AuthService} from '../../../core/service/auth.service';

@Component({
    selector: 'app-file-download',
    template: '<button type="button" (click)="downloadFile()" class="btn btn-secondary btn-sm">' +
                '<span *ngIf="!downloading">Download</span>' +
                '<span *ngIf="downloading"><i class="fa fa-spinner fa-pulse" ></i></span>' +
              '</button>',
})
export class FileDownloadComponent {

    /**
     * Input parameters. File pk, filename and file type
     */
    @Input() filepk: number;
    @Input() filename: string;
    @Input() filetype: string = 'text/plain';


    extSource: string = '';
    downloading: boolean;

   /**
    *
    * @param fileDownload
    * @param authService
    */
    constructor(private fileDownload: FileDownloadService, private authService: AuthService) {
        this.downloading = false;
    }

    /**
     * Performs file download
     */
    downloadFile() {
        this.downloading = true;
        this.fileDownload.downloadFile(this.filepk, this.filename, this.authService.getSource()).subscribe(
            (r) => {
                const linkElement = document.createElement('a');

                if(r.byteLength == 0){
                    this.fileDownload.getSubject().next('File with name ' + this.filename + ' cannot be downloaded');
                }
                else{
                    try {
                        const blob = new Blob([r], { type: this.filetype + '; charset=UTF-8' });
                        const url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', this.filename);

                        const clickEvent = new MouseEvent('click', {'view': window, 'bubbles': true, 'cancelable': false});
                        linkElement.dispatchEvent(clickEvent);

                    } catch (ex) {
                        console.log(ex);
                    }
                }


                this.downloading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/shared/components/file_download/file_download.component.ts